module.exports = __webpack_public_path__ + "static/img/zpbj_icon.png";